/* ==========================================================================
   LAUZON — mega menu behaviour
   Disclosure-pattern mega nav (WAI disclosure navigation): tabs are buttons
   with aria-expanded; panels open on click, hover intent, or keyboard.
   Escape closes and restores focus; focus leaving a tab's subtree closes it;
   arrow keys traverse the tab row. The mobile drawer is a modal dialog with
   a real focus trap.

   Clicks and keys are delegated on document (bound once), so sections
   re-rendered by the theme editor keep working; hover intent is bound per
   item with an idempotent data flag and re-run on shopify:section:load.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__lauzonMegaInit) return;
  window.__lauzonMegaInit = true;

  var HOVER_OPEN_MS = 90;
  var HOVER_CLOSE_MS = 160;
  /* Must match the desktop-nav breakpoint in lauzon-mega-menu.css */
  var desktop = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- Desktop panels ---------- */

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mega-item]'));
  }

  function openItem(item) {
    items().forEach(function (other) {
      if (other !== item) closeItem(other);
    });
    item.classList.add('is-open');
    var tab = item.querySelector('.meganav-tab');
    if (tab) tab.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    var tab = item.querySelector('.meganav-tab');
    if (tab) tab.setAttribute('aria-expanded', 'false');
  }

  function closeAll() {
    items().forEach(closeItem);
  }

  function openedItem() {
    return document.querySelector('[data-mega-item].is-open');
  }

  // Hover intent, per item (idempotent; re-run on section reload)
  function bindHover(root) {
    if (!canHover.matches) return;
    (root || document).querySelectorAll('[data-mega-item]').forEach(function (item) {
      if (item.dataset.megaHover) return;
      item.dataset.megaHover = '1';
      var openTimer, closeTimer;
      item.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(function () { openItem(item); }, HOVER_OPEN_MS);
      });
      item.addEventListener('mouseleave', function () {
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(function () { closeItem(item); }, HOVER_CLOSE_MS);
      });
    });
  }
  bindHover(document);

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.meganav-tab');
    if (tab) {
      var item = tab.closest('[data-mega-item]');
      if (item.classList.contains('is-open')) closeItem(item);
      else openItem(item);
      return;
    }
    // Click anywhere outside the nav closes the open panel
    if (openedItem() && !e.target.closest('.meganav')) closeAll();

    var burger = e.target.closest('[data-mega-burger]');
    if (burger) { openDrawer(burger); return; }

    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var acc = e.target.closest('.mega-drawer-acc');
    if (acc) {
      var expanded = acc.getAttribute('aria-expanded') === 'true';
      acc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var sub = document.getElementById(acc.getAttribute('aria-controls'));
      if (sub) sub.hidden = expanded;
    }
  });

  // Focus leaving an open tab's subtree closes it (keyboard Tab-through)
  document.addEventListener('focusin', function (e) {
    var open = openedItem();
    if (open && !open.contains(e.target)) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    // Drawer first: it is modal
    var drawer = document.querySelector('.mega-drawer:not([hidden])');
    if (drawer) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key === 'Tab') trapFocus(e, drawer);
      return;
    }

    var open = openedItem();
    if (e.key === 'Escape' && open) {
      e.preventDefault();
      var tab = open.querySelector('.meganav-tab');
      closeAll();
      if (tab) tab.focus();
      return;
    }

    // Tab-row traversal (roving via arrow keys, WAI disclosure nav pattern)
    var current = e.target.closest && e.target.closest('.meganav-tab, .meganav-link');
    if (!current || !current.closest('.meganav')) return;
    var row = Array.prototype.slice.call(
      current.closest('.meganav').querySelectorAll('.meganav-tab, .meganav-link')
    );
    var idx = row.indexOf(current);
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      row[(idx + 1) % row.length].focus();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      row[(idx - 1 + row.length) % row.length].focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      row[0].focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      row[row.length - 1].focus();
    } else if ((e.key === 'ArrowDown') && current.classList.contains('meganav-tab')) {
      e.preventDefault();
      var item = current.closest('[data-mega-item]');
      openItem(item);
      var first = item.querySelector('.mega-panel a');
      if (first) first.focus();
    }
  });

  // Crossing the breakpoint tidies up whichever nav the new width cannot show.
  // Downward: close any open desktop panel. Upward: close the drawer — the CSS
  // hides it at >=990 but the element stays open, so body.megadrawer-open (and
  // its overflow:hidden) survived the resize and locked page scroll.
  var onDesktopChange = function () {
    if (desktop.matches) closeDrawer();
    else closeAll();
  };
  if (desktop.addEventListener) desktop.addEventListener('change', onDesktopChange);
  else desktop.addListener(onDesktopChange);

  /* ---------- Mobile drawer ---------- */

  var drawerReturnFocus = null;

  function openDrawer(burger) {
    var drawer = document.querySelector('.mega-drawer');
    if (!drawer) return;
    drawerReturnFocus = burger;
    drawer.hidden = false;
    document.body.classList.add('megadrawer-open');
    burger.setAttribute('aria-expanded', 'true');
    var closeBtn = drawer.querySelector('[data-drawer-close]:not(.mega-drawer-overlay)');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var drawer = document.querySelector('.mega-drawer');
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('megadrawer-open');
    var burger = document.querySelector('[data-mega-burger]');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (drawerReturnFocus && document.contains(drawerReturnFocus)) drawerReturnFocus.focus();
    drawerReturnFocus = null;
  }

  function trapFocus(e, drawer) {
    var focusables = Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled])')
    ).filter(function (el) {
      return el.offsetParent !== null && el.getAttribute('tabindex') !== '-1';
    });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- Theme editor ---------- */

  document.addEventListener('shopify:section:load', function (event) {
    bindHover(event.target);
    closeDrawer();
  });
})();
